export let ProcessorPickerStatus;
(function (ProcessorPickerStatus) {
  ProcessorPickerStatus["active"] = "active";
})(ProcessorPickerStatus || (ProcessorPickerStatus = {}));